import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { OperatorAuthService } from './operator-auth.service';

export const anonymousOnlyGuard: CanActivateFn = () => {
  const auth = inject(OperatorAuthService);
  const router = inject(Router);

  return auth.ensureAuthenticated().pipe(map((isAuthenticated) => (isAuthenticated ? router.createUrlTree(['/dashboard']) : true)));
};
